import React from 'react';

const ControlsTab = ({ exactMatch, setExactMatch, searchDepth, setSearchDepth, aggregation, setAggregation, minQualityScore, setMinQualityScore }) => (
  <div data-testid="cp-ctrl-panel">
    <div style={{ fontSize: '0.5rem', color: '#555', marginBottom: 6 }}>SEARCH CONTROLS</div>
    <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ color: '#71717a', fontSize: '0.55rem' }}>Exact Match</span>
        <label className="filter-pill" style={{ display: 'flex', alignItems: 'center', gap: 3, cursor: 'pointer', borderRadius: 4 }}>
          <input type="checkbox" checked={exactMatch} onChange={() => setExactMatch(!exactMatch)}
            style={{ width: 10, height: 10, accentColor: '#f59e0b' }} />
          <span style={{ color: exactMatch ? '#f59e0b' : '#555', fontSize: '0.5rem' }}>{exactMatch ? 'ON' : 'OFF'}</span>
        </label>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ color: '#71717a', fontSize: '0.55rem' }}>Search Depth</span>
        <select value={searchDepth} onChange={e => setSearchDepth(parseInt(e.target.value))}
          style={{ background: 'rgba(253, 230, 138,0.06)', border: '1px solid rgba(253, 230, 138,0.15)', color: '#38bdf8', padding: '2px 5px', borderRadius: 4, fontSize: '0.52rem' }}>
          <option value={10}>10</option><option value={20}>20</option><option value={30}>30</option>
          <option value={50}>50</option><option value={100}>100</option>
        </select>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ color: '#71717a', fontSize: '0.55rem' }}>Category Logic</span>
        <div style={{ display: 'flex', gap: 4 }}>
          {['or', 'and', 'and_or'].map(v => (
            <label key={v} className="filter-pill" style={{ display: 'flex', alignItems: 'center', gap: 2, cursor: 'pointer', borderRadius: 4 }}>
              <input type="radio" name="cp-agg" value={v} checked={aggregation === v}
                onChange={() => setAggregation(v)} style={{ width: 9, height: 9, accentColor: '#38bdf8' }} />
              <span style={{ color: aggregation === v ? '#38bdf8' : '#444', fontSize: '0.48rem', fontWeight: aggregation === v ? 700 : 400 }}>{v.toUpperCase()}</span>
            </label>
          ))}
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ color: '#71717a', fontSize: '0.55rem' }}>Min Quality</span>
        <input type="range" min={0} max={100} step={5} value={minQualityScore}
          onChange={e => setMinQualityScore(parseInt(e.target.value))}
          style={{ width: 80, height: 8, accentColor: '#38bdf8' }} />
        <span style={{ color: '#38bdf8', fontSize: '0.5rem', width: 20, textAlign: 'right' }}>{minQualityScore}</span>
      </div>
    </div>
  </div>
);

export default ControlsTab;
